export interface FloorPlan {
  id: string;
  area: string;
  type: string;
  displayText: string;
}

export const floorPlans: FloorPlan[] = [
  {
    id: '1r',
    area: '30㎡',
    type: '1R',
    displayText: '30㎡・1R'
  },
  {
    id: '1ldk',
    area: '45㎡',
    type: '1LDK',
    displayText: '45㎡・1LDK'
  },
  {
    id: '2ldk',
    area: '60㎡',
    type: '2LDK',
    displayText: '60㎡・2LDK'
  }
];